import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const BellInactive = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00047 1.5C9.32257 1.5 10.4392 1.86878 11.2464 2.59949L10.4762 3.25554C9.89755 2.78041 9.07496 2.5 8.00047 2.5C6.80807 2.5 5.92588 2.84533 5.343 3.41889C4.7611 3.99149 4.41714 4.85093 4.41714 6V8.41698L3.42375 9.2632C3.42 9.17468 3.41714 9.08448 3.41714 9V6C3.41714 4.64907 3.82619 3.50851 4.64162 2.70611C5.45608 1.90467 6.61555 1.5 8.00047 1.5ZM12.3346 4.31265L14.4236 2.47034C14.6307 2.28769 14.6505 1.97173 14.4679 1.76462C14.2852 1.55752 13.9692 1.53769 13.7621 1.72034L1.01206 12.9647C0.804955 13.1473 0.785128 13.4633 0.967777 13.6704C1.15043 13.8775 1.46639 13.8973 1.6735 13.7147L2.65475 12.8493C2.83179 12.9454 3.03464 13 3.25023 13H5.54065C5.64827 13.6429 5.9636 14.1243 6.38315 14.4527C6.88567 14.846 7.5012 14.9929 8.00047 14.9929C8.49975 14.9929 9.11527 14.846 9.6178 14.4527C10.0373 14.1243 10.3527 13.6429 10.4603 13H13.2505C13.9408 13 14.5005 12.4404 14.5005 11.75C14.5005 11.03 13.9173 10.5726 13.3878 10.4292C13.0091 10.3266 12.8314 10.129 12.7292 9.90429C12.6141 9.65097 12.5838 9.33405 12.5838 9V6C12.5838 5.39088 12.5006 4.82452 12.3346 4.31265ZM11.4955 5.0526L3.61781 12H5.50047H6.00047H10.0005H10.5005H13.2505C13.3885 12 13.5005 11.8881 13.5005 11.75C13.5005 11.6896 13.4774 11.6255 13.4148 11.559C13.3489 11.489 13.247 11.4271 13.1265 11.3944C12.448 11.2107 12.0391 10.8026 11.8189 10.3181C11.6116 9.86216 11.5838 9.36631 11.5838 9V6C11.5838 5.65867 11.5535 5.34289 11.4955 5.0526ZM6.56314 13C6.64898 13.31 6.81382 13.5199 6.99954 13.6652C7.29092 13.8933 7.6754 13.9929 8.00047 13.9929C8.32555 13.9929 8.71003 13.8933 9.00141 13.6652C9.18713 13.5199 9.35196 13.31 9.43781 13H6.56314Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default BellInactive
